/**
 * Helper puro: retorna true para qualquer modelo de disputa que possui uma
 * fase eliminatória (chaveamento): ELIMINACAO_SIMPLES, ELIMINACAO_DUPLA e
 * GRUPOS_ELIMINACAO. Retorna false para os demais (incluindo GRUPO_UNICO,
 * que é round-robin sem mata-mata, além de null, undefined e strings
 * desconhecidas).
 *
 * Simétrico a `temFaseDeGrupos`: juntos descrevem as capabilities estruturais
 * que dirigem a renderização das abas (Fase de Grupos / Eliminatórias) sem
 * literais de modelo espalhados (anti-pattern de duplicação).
 *
 * Util puro: sem dependências de camadas superiores (componentes, services,
 * context). Direção permitida: pages/components → utils.
 */
export const temFaseEliminatoria = (modelo?: string | null): boolean =>
  modelo === 'ELIMINACAO_SIMPLES' ||
  modelo === 'ELIMINACAO_DUPLA' ||
  modelo === 'GRUPOS_ELIMINACAO';
